import {Component, HostListener, OnInit} from '@angular/core';
import { BasicFilters } from '../../model/filters/basic-filters';
import { Tenant } from '../../model/tenant';
import { TenantsService } from '../../services/tenants.service';
import { SortOrder } from '../../model/sort-order';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TranslocoService } from '@ngneat/transloco';
import { CommonMessagesService } from '../../services/common-messages.service';
import { FiltersService } from '../../services/filters.service';

@Component({
  selector: 'app-tenants',
  templateUrl: './tenants.component.html',
  styleUrls: ['./tenants.component.scss']
})
export class TenantsComponent implements OnInit {

  public tenants: Tenant[];
  public totalTenants: number;
  public loadingTenants: boolean;

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: BasicFilters;
  public filtersFilled: boolean;

  public confirmationVisible: boolean;
  public tenantToDelete: Tenant;

  constructor(private tenantsService: TenantsService,
              private messageService: MessageService,
              private i18n: TranslocoService,
              private confirmationService: ConfirmationService,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<BasicFilters>) {
    this.currentFilters = new BasicFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    this.tenants = new Array(this.rows);
  }

  private loadTenants(offset?: number, limit?: number): void {
    this.loadingTenants = true;
    this.tenants = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.tenantsService.getTenants(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters : this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.tenants = response.tenants;
        this.totalTenants = response.totalElements;
        this.loadingTenants = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadTenants(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new BasicFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadTenants(this.first / this.rows, this.rows);
  }

  showDeleteTenantConfirmation(): void {
    this.confirmationVisible = true;
  }

  confirmAndDelete(tenant: Tenant): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.tenantToDelete = tenant;
      this.showDeleteTenantConfirmation();
    });
  }

  deleteTenant(uuid: string): void {
    this.tenantsService.deleteTenant(uuid).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadTenants(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) { return; }
    const uuids = this.selected.map(item => (item.uuid));

    this.tenantsService.deleteTenants(uuids).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadTenants(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  trimFieldsForm(filters: BasicFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
